import Swal from 'sweetalert2';
import {
    authenticateUserService,
    checkAutoLogin,
    fetchLoggedInUser,
    fetchPrivileges,
    forgotPassword,
    formatAuthError,
    formatError,
    formatSuccess,
    login,
    logout,
    register,
    resetPassword,
    runLogoutTimer,
    saveTokenInLocalStorage,
    sendOTP,
    verifyAppIdService,
    verifyOTP,
} from '../../services/AuthService';
import { consentResponse } from '../../services/AdminService';

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const AUTH_CONFIRMED_ACTION = '[auth action] confirmed login';
export const AUTH_FAILED_ACTION = '[auth action] failed login';
export const USER_CONFIRMED_ACTION = '[verify action] confirmed login';
export const USER_FAILED_ACTION = '[verify action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const NAVTOGGLE = 'NAVTOGGLE';
export const SET_SHOW_OTP_FIELD = 'SET_SHOW_OTP_FIELD';
export const FETCH_USER_SUCCESS_ACTION = '[user action] confirmed user';
export const FETCHED_USER_CANCEL_ACTION = '[user action] cancel user';
export const FETCHED_USER_SUCCESS_ACTION = '[user action] confirmed userfetched';
export const FETCH_PRIVILEGES = '[auth action] success privilege';
export const CONSENT_RESPONSE = '[auth action] consent response';
export function authenticateUserAction(regNo) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        authenticateUserService(regNo)
            .then((response) => {
                formatSuccess(response.data.message)
                dispatch(authConfirmedAction(response.data.message));

            })
            .catch((error) => {
                //console.log(error);
                const errorMessage = formatError(error.response.data.message);
                dispatch(authFailedAction(errorMessage));

            }).finally(() => {
                dispatch(loadingToggleAction(false));
            })
    };
}
export function verifyAppId(regNo) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        verifyAppIdService(regNo)
            .then((response) => {
                switch (response.data.role.toLowerCase()) {
                    case "candidate":
                        dispatch(verifyUserConfirmedAction(response.data));
                        break;
                    default:
                        dispatch(authenticateUserAction(regNo));
                        break;
                }

            })
            .catch((error) => {
                //console.log(error);
                const errorMessage = formatError(error.response?.data?.message);
                dispatch(verifyUserCancelAction(errorMessage));

            }).finally(() => {
                dispatch(loadingToggleAction(false));
            })
    };
}

export function Logout(navigate) {
    sessionStorage.removeItem('userDetails');
    navigate('/login');
    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(regNo, otp, navigate) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        login(regNo, otp)
            .then((response) => {
                saveTokenInLocalStorage(response.data);
                runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 100,
                    navigate,
                );
                dispatch(loginConfirmedAction(response.data));
                dispatch(showOtpFieldAction(false));
                dispatch(fetchPrivilegesAction());
                switch (response.data.role.toLowerCase()) {
                    case "candidate":
                        switch (response.data.status) {
                            case "REGISTERED":
                                navigate("/district-preferences");
                                break;
                            case "DISTRICT_SUBMITTED":
                                navigate("/post-preferences");
                                break;
                            case "POST_SUBMITTED":
                                navigate("/show-preferences");
                                break;
                            default:
                                navigate("/application-form");
                                break;
                        }
                        break;
                    default:
                        navigate(response.data.landingPage ? response.data.landingPage : "/dashboard")
                        break;
                }
            })
            .catch((error) => {
                //console.log(error);
                const errorMessage = formatError(error.response?.data?.message);
                dispatch(loginFailedAction(errorMessage));
            }).finally(() => {
                dispatch(loadingToggleAction(false));
            })
    };
}
export function fetchLoggedInUserAction(navigate) {
    return (dispatch) => {
        fetchLoggedInUser().then((response) => {
            dispatch(fetchUserSuccess(response.data))
            if (navigate) {
                switch (response.data.role.toLowerCase()) {
                    case "candidate":
                        if (response.data.status == null) {
                            navigate("/application-form")
                        } else if (response.data.status === "REGISTERED") {
                            navigate("/district-preferences")
                        } else if (response.data.status === "DISTRICT_SUBMITTED") {
                            navigate("/post-preferences")
                        } else if (response.data.status === "POST_SUBMITTED") {
                            navigate("/show-preferences")
                        }
                        break;
                    default:
                        navigate(response.data?.landingPage ? response.data?.landingPage : "/home")
                        break;
                }
            }
        }).catch((error) => {
            formatError(error.response?.data?.message);
            if (error.status === 401)
                dispatch(Logout(navigate))
        })
    }
}
export function fetchLoggedInUserAct() {
    return (dispatch) => {
        fetchLoggedInUser().then((response) => {
            dispatch(fetchUserSuccess(response.data))
        }).catch((error) => {
            formatError(error.response.data?.message);
        })
    }
}
export function fetchPrivilegesAction() {
    return (dispatch) => {
        fetchPrivileges().then((response) => {
            dispatch({ type: FETCH_PRIVILEGES, payload: response.data })
        }).catch((error) => {
            // formatError(error.response.data.message);
        })
    }
}
export function fetchLoggedInUserActNav(navigate) {
    return (dispatch) => {
        fetchLoggedInUser().then((response) => {

        }).catch((error) => {
            formatAuthError(error?.response?.data?.message);
            dispatch(Logout(navigate))
        })
    }
}
export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function authConfirmedAction(data) {
    return {
        type: AUTH_CONFIRMED_ACTION,
        payload: data,
    };
}
export function verifyUserConfirmedAction(data) {
    return {
        type: FETCHED_USER_SUCCESS_ACTION,
        payload: data,
    };
}
export function verifyUserCancelAction() {
    return {
        type: FETCHED_USER_CANCEL_ACTION,
    };
}

export function consentResponseAction(response) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        consentResponse(response).then((response) => {
            formatSuccess(response?.data?.message)
           dispatch({ type: CONSENT_RESPONSE, payload: true })
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}

export function showOtpFieldAction(data) {
    return {
        type: SET_SHOW_OTP_FIELD,
        payload: data,
    };
}

export function authFailedAction(data) {
    return {
        type: AUTH_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export const navtoggle = () => {
    return {
        type: NAVTOGGLE,
    };
};
function fetchUserSuccess(response) {
    return {
        type: FETCH_USER_SUCCESS_ACTION,
        payload: response
    }
}

